import { useMutation } from "@tanstack/react-query";
import { prvListapi } from "components/api/comm";
import Term from "components/view/join/email/term";
import { IPrv } from "interface";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export default function TermPage() {
  const { t } = useTranslation();
  // const {  } = useJoinContext();
  const checkRef = useRef<HTMLDivElement>(null);
  const [prvList, setPrvList] = useState<IPrv[] | null>(null);

  //약관 리스트 조회
  const prvsMutation = useMutation({
    mutationFn: prvListapi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          const prvs = data.prvList.sort((a: any, b: any) => {
            return Number(a.prvCd.slice(2, 3)) - Number(b.prvCd.slice(2, 3));
          });
          setPrvList(prvs);
        }
      }
    },
  });

  useEffect(() => {
    prvsMutation.mutate();
  }, []);

  return (
    <>
      <Term prvList={prvList} checkRef={checkRef} />
    </>
  );
}
